import { render } from "./ViewDnsRecords.vue?vue&type=template&id=3d7d14c8&scoped=true"
import script from "./ViewDnsRecords.vue?vue&type=script&lang=js"
export * from "./ViewDnsRecords.vue?vue&type=script&lang=js"

import "./ViewDnsRecords.vue?vue&type=style&index=0&id=3d7d14c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7d14c8"]])

export default __exports__